var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33594C4.32416 1.33594 1.3335 4.3266 1.3335 8.0026C1.3335 11.6786 4.32416 14.6693 8.00016 14.6693C11.6762 14.6693 14.6668 11.6786 14.6668 8.0026C14.6668 4.3266 11.6762 1.33594 8.00016 1.33594ZM8.00016 13.3359C5.0595 13.3359 2.66683 10.9433 2.66683 8.0026C2.66683 5.06194 5.0595 2.66927 8.00016 2.66927C10.9408 2.66927 13.3335 5.06194 13.3335 8.0026C13.3335 10.9433 10.9408 13.3359 8.00016 13.3359Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 4.66406H7.3335V8.66406H11.3335V7.33073H8.66683V4.66406Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTime);
export default __webpack_public_path__ + "static/media/bx-time.7330849bd74cd8d015d77fc071763fb8.svg";
export { ForwardRef as ReactComponent };